import { render, staticRenderFns } from "./orderColumn.vue?vue&type=template&id=1423bdd0&scoped=true&"
import script from "./orderColumn.vue?vue&type=script&lang=js&"
export * from "./orderColumn.vue?vue&type=script&lang=js&"
import style0 from "./orderColumn.vue?vue&type=style&index=0&id=1423bdd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1423bdd0",
  null
  
)

export default component.exports